import { useState, useEffect } from "react";
import { List, Container } from "@mui/material";
import SideMenuItem from "./SideMenuItem";
import SideMenuItemWithSubMenu from "./SideMenuItemWithSubMenu";

export default function SideMenu({ menuItems }) {
  const [activeItem, setActiveItem] = useState();

  useEffect(() => {
    const selected = menuItems.find((i) => i.isSelected);
    if (selected) {
      setActiveItem(selected.menuName);
    }
  }, [menuItems]);

  function onClick(item, event) {
    setActiveItem(item.menuName);
  }

  return (
    <Container className="side-menu">
      <nav>
        <List>
          {menuItems.map((item, i) =>
            item.hasSideMenu ? (
              <SideMenuItemWithSubMenu
                key={item.menuName}
                item={item}
                activeItem={activeItem}
                setActiveItem={setActiveItem}
                onClick={(event) => onClick(item, event)}
              />
            ) : (
              <SideMenuItem
                key={item.menuName}
                item={item}
                activeItem={activeItem}
                onClick={(event) => onClick(item, event)}
              />
            )
          )}
        </List>
      </nav>
    </Container>
  );
}
